import { useState } from 'react';

const faqItems = [
  {
    q: 'Czym jest Kakobuy Spreadsheet?',
    a: 'Kakobuy Spreadsheet to lista produktów i przewodników, które pomagają szybciej znaleźć interesujące produkty. To uporządkowana baza danych tworzona przez społeczność, która ułatwia wyszukiwanie i porównywanie produktów z różnych kategorii.',
  },
  {
    q: 'Czy Kakobuy Spreadsheet jest darmowy?',
    a: 'Dostępność list zależy od źródła. Nasza strona pomaga użytkownikom znaleźć informacje i korzystać z nich efektywnie, bez dodatkowych opłat.',
  },
  {
    q: 'Czy Kakobuy jest bezpieczny?',
    a: 'Bezpieczeństwo zależy od sposobu korzystania. Zawsze należy sprawdzać sprzedawców, opinie oraz informacje o produkcie przed dokonaniem zakupu. Zalecamy również korzystanie z bezpiecznych metod płatności i dokładne czytanie opisów produktów.',
  },
  {
    q: 'Jak często aktualizowane są listy produktów?',
    a: 'Listy produktów Kakobuy Spreadsheet są regularnie aktualizowane przez społeczność. Nowe produkty i kategorie są dodawane na bieżąco, aby zapewnić dostęp do najbardziej aktualnych informacji.',
  },
  {
    q: 'Jakie kategorie produktów są dostępne?',
    a: 'Kakobuy Spreadsheet obejmuje szeroki zakres kategorii, w tym sneakersy, odzież (bluzy, t-shirty, kurtki, spodnie), akcesoria, torby, paski, perfumy i wiele więcej. Pełną listę kategorii znajdziesz w sekcji kategorii na naszej stronie.',
  },
];

const faqPageSchema = {
  "@context": "https://schema.org",
  "@type": "FAQPage",
  "mainEntity": faqItems.map((item) => ({
    "@type": "Question",
    "name": item.q,
    "acceptedAnswer": {
      "@type": "Answer",
      "text": item.a,
    },
  })),
};

export default function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section id="faq" className="py-16 md:py-24 bg-background-50">
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(faqPageSchema) }}
      />
      <div className="max-w-3xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mb-4">
            Najczęściej Zadawane Pytania
          </h2>
        </div>

        <div className="space-y-3">
          {faqItems.map((item, idx) => (
            <div
              key={idx}
              className="border border-background-200/80 rounded-xl overflow-hidden bg-background-50"
            >
              <button
                onClick={() => setOpenIndex(openIndex === idx ? null : idx)}
                className="w-full flex items-center justify-between px-5 py-4 text-left hover:bg-background-100/50 transition-colors duration-150 cursor-pointer"
              >
                <span className="text-sm font-semibold text-foreground-900 pr-4">{item.q}</span>
                <div className={`w-5 h-5 flex-shrink-0 flex items-center justify-center transition-transform duration-200 ${
                  openIndex === idx ? 'rotate-45' : ''
                }`}>
                  <i className="ri-add-line text-foreground-500"></i>
                </div>
              </button>
              <div
                className={`overflow-hidden transition-all duration-300 ${
                  openIndex === idx ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'
                }`}
              >
                <div className="px-5 pb-5">
                  <p className="text-sm text-foreground-600 leading-relaxed">{item.a}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}